import { Feedback, WarningOptions } from './feedback.js';

export default class WarningFeedback extends Feedback {

  /* eslint-disable no-useless-constructor */
  /**
   * @param {object} options 
   */
  constructor( options ) {
    super( options );
  }

}



// WEBPACK FOOTER //
// ./src/model/session/warningFeedback.js